import {Injectable} from "@angular/core";

@Injectable()

export class CookiesService {

    get(name: string = '') {
        if(name.length) {
            let value = this.get_all()[name];
            return value != undefined ? value : '';
        }
        return this.get_all();
    }

    private get_all() {
        let cookies = {};
        let cookies_array = document.cookie.split('; ');
        for(let key in cookies_array) {
            let cookie = cookies_array[key].split('=');
            cookies[cookie[0]] = cookie[1];
        }
        return cookies;
    }

    set(name: string, value: any) {
        document.cookie = name + '=' + value +'; Path=/;';
    }

    delete(name: string) {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
}



// WEBPACK FOOTER //
// ./src/app/services/cookies.service.ts